import React, { useState } from 'react';
import './VideoGrid.css';




// Import the image files with correct paths relative to this component
import thumbnail1 from '../images/2025-TILESX-01-800w.png';
import thumbnail2 from '../images/2025-TILESX-05-800w.png';
import thumbnail3 from '../images/2025-TILESX-07-800w.png';
// import thumbnail1 from '../images/vid-ph-2025-09-800w.png';
// import thumbnail2 from '../images/vid-ph-2025-13-800w.png';
// import thumbnail3 from '../images/vid-ph-2025-20-800w.png';

const VideoGrid = () => {
  // Video data array with all the information
  const videos = [
    {
      id: 1,
      url: "https://freeweb3.infura-ipfs.io/ipfs/QmRiUjGpBqvxbwHP2yrk5HKN1NiAkGCZxaMvi8qoAukNU9",
      title: "INTRODUCTION",
      description: "Learn about Web3 and Evidencer",
      thumbnail: thumbnail1
    },
    {
      id: 2,
      url: "https://freeweb3.infura-ipfs.io/ipfs/QmTxQKupcosWpap1HFAFtebq2VkyDvDf4ekVHxzbvxYnB9",
      title: "FEATURES & BENEFITS",
      description: "Features of Evidencer and Web3",
      thumbnail: thumbnail2
    },
    {
      id: 3,
      url: "https://freeweb3.infura-ipfs.io/ipfs/QmUFGWoVTfuBYTCJ5agv3oixha9Zb3bN7mjRKABAvkSJUU",
      title: "THREE EASY STEPS",
      description: "Get started with Web3 for free now.",
      thumbnail: thumbnail3
    },
    // {
    //   id: 4,
    //   url: "https://freeweb3.infura-ipfs.io/ipfs/QmePdaQ5SuvnCbZAxUkny3vBXiPVxRbARZPSyQpX9n3aPA",
    //   title: ".",
    //   description: ".",
    //   thumbnail: thumbnail4
    // },
    // {
    //   id: 5,
    //   url: "https://freeweb3.infura-ipfs.io/ipfs/QmUFGWoVTfuBYTCJ5agv3oixha9Zb3bN7mjRKABAvkSJUU",
    //   title: ".",
    //   description: ".",
    //   thumbnail: thumbnail5
    // },
    // {
    //   id: 6,
    //   url: "https://freeweb3.infura-ipfs.io/ipfs/QmcqgyUBhRrEfV6fqgwnjz9kibwywRZ1Fz3ZgGM5LcLfus",
    //   title: ".",
    //   description: ".",
    //   thumbnail: thumbnail6
    // }
  ];

        // url="https://freeweb3.infura-ipfs.io/ipfs/QmRiUjGpBqvxbwHP2yrk5HKN1NiAkGCZxaMvi8qoAukNU5"
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmaAprHEj1aZEnKwDHtym7ScTemRkCjqFXBuWoMmMFteuB"
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmUFGWoVTfuBYTCJ5agv3oixha9Zb3bN7mjRKABAvkSJUU"
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmUvjqZWoispVTo8W2E7jMwqNcRuVWPfi51xqYivsWeME3"
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmUvjqZWoispVTo8W2E7jMwqNcRuVWPfi51xqYivsWeME3"
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmaAprHEj1aZEnKwDHtym7ScTemRkCjqFXBuWoMmMFteuB"
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmcYvD7ReHmYmEUza3PWLX8Bkz8mGkgu3rF3euNDNfcagY"
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmePdaQ5SuvnCbZAxUkny3vBXiPVxRbARZPSyQpX9n3aPA" 
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmUFGWoVTfuBYTCJ5agv3oixha9Zb3bN7mjRKABAvkSJUU" 
        // url="https://freeweb3.infura-ipfs.io/ipfs/QmcqgyUBhRrEfV6fqgwnjz9kibwywRZ1Fz3ZgGM5LcLfus"

  // State to track which video is currently playing
  const [activeVideo, setActiveVideo] = useState(null);

  // Handle click on a video monitor
  const handleVideoClick = (videoId) => {
    if (activeVideo === videoId) {
      setActiveVideo(null); // Turn off if clicked again
    } else {
      setActiveVideo(videoId); // Otherwise activate this video
    }
  };

  return (
    <div className="video-grid-container">
<h2 className="video-grid-title" style={{ color: "cornflowerblue" }}>Getting to Know Evidencer</h2>
      <div className="video-grid">
        {videos.map((video) => (
          <div key={video.id} className="video-monitor">
            <div className="monitor-frame">
              <div className="monitor-screen">
                {activeVideo === video.id ? (
                  <video
                    controls
                    autoPlay
                    className="video-player"
                    src={video.url}
                  >
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <div 
                    className="video-thumbnail" 
                    onClick={() => handleVideoClick(video.id)}
                  >
                    <img src={video.thumbnail} alt={video.title} />
                    <div className="play-button">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
                      </svg>
                    </div>
                    <div className="video-info">
                      <h3>{video.title}</h3>
                      <p>{video.description}</p>
                    </div>
                  </div>
                )}
              </div>
              <div className="monitor-stand"></div>
              <div className="monitor-base"></div>
              <div className="monitor-controls">
                {activeVideo === video.id ? (
                  <button 
                    className="stop-button" 
                    onClick={() => setActiveVideo(null)}
                  >
                    Stop
                  </button>
                ) : (
                  <button 
                    className="play-video-button" 
                    onClick={() => handleVideoClick(video.id)}
                  >
                    Play
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoGrid;